/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import { ArrowLeftOutlined, CloudUploadOutlined, DeleteOutlined, EditOutlined, EyeOutlined, FilterOutlined, RightCircleTwoTone, DownCircleTwoTone } from '@ant-design/icons';
import {
    Button, Form,
    Input,
    Modal,
    Space,
    Table,
    Tabs,
    Tooltip,
    Typography,
    Upload, notification, DatePicker, Drawer, Select, Layout, Row, Col, Card,
    Radio
} from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import history from '../../services/history';

import PricingTable from './PricingTable';
import { AddOrUpdateConfigData, generateData360Pricing, getConfogListFromDatabse } from '../../redux/Pricing gudiance/saga';
import { authenticateCurrentUser } from '../../services/auth';
import FeatureLicensePage from './FeatureLicensePage';
import Data360Config from './Data360Config';
import FeatureLicenseConfig from './FeatureLicenseConfig';



const { Option } = Select;
const { Title, Text } = Typography;
const { TabPane } = Tabs;
//const { TabPane } = Tabs;
//const { Column } = Table;
//const { Search } = Input;

//const { Option } = Select;
const Data360Page = (props) => {

    const {

    } = props;


    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isMasterModalVisible, setIsMasterModalVisible] = useState(false);

    const [isRead, setIsRead] = useState(false);
    const [prevPageNumber, setPrevPageNumber] = useState(1);
    const [prevPagesize, setPrevPagesize] = useState(10);
    const [searchType, setSearchType] = useState({});

    const [userName, setUserName] = useState('');
    const [userGroup, setUserGroup] = useState([]);

    const [activeKey, setActiveKey] = useState('1')
    const [activeKeyLine, setActiveKeyLine] = useState('1')
    const [selectedTap, setSelectedTap] = useState('Log');
    const [tapsList, setTaplist] = useState(['Log', 'Analysis']);

    const [showPricingPage, setShowPricingPage] = useState(false);
    const [projectDetails, setProjectDetails] = useState({});
    const [diameterList, setDiameterList] = useState([])
    const [equipmentType, setEquipmentType] = useState('IWM');

    // const [formData, setFormData] = useState({})
    const [Contractor, setContractor] = useState('Rent');
    const [License_Duration, setLicense_Duration] = useState(1);
    const [License_Tier, setLicense_Tier] = useState('Basic');
    const [SaveLoading, setSaveLoading] = useState(false);
    const [showConfiguration, setShowConfiguration] = useState(false);
    const [showFeatureConfiguration, setShowFeatureConConfiguration] = useState(false);
    const [GenerateLoading, setGenerateLoading] = useState(false)
    const [showPricingTable, setShowPricingTable] = useState(false)
    const [ConfigData, setConfigData] = useState({})
    const [isInputfeildChanged, setIsInputfeildChanged] = useState(false)
    const [formData, setFormData] = useState(
        {
            "Project_details": {
                "No_of_units": 1,
                "License_mode": "Sale",
                "Project_duration": 12,
                "Tier": "Basic",
                "License_duration": "1 Year"
            },
            "Hardware": {
                "Unit_cost": 3000,
                "Utilization": 0.6,
                "Margin": 0.6,
                "Rental_rate": 0.10
            },
            "Application": {
                "Payback_Period": 12,
                "Dev_cost": 300000,
                "Margin": 0.6,
                "Units_per_Year": 40
            },
            "License_weightage": {
                "Basic": 0.5,
                "Standard": 0.75,
                "Premium": 1
            },
            "License_duration_weightage": {
                "1_year": 1.25,
                "2_year": 1.0,
                "3_year": 0.75,
                "5_year": 0.6,
                "Perpetual": 0.5
            },
            "License_duration_discount": {
                "<12": 1,
                "13to24": 0.95,
                "25to36": 0.9,
                "37to60": 0.85,
                "Perpetual": 0.8

            },
            "Others": {
                "Recurring": {
                    "Internet": 50,
                    "AWS": 50,
                    "Maintenance": 100,
                    "Premium": 100
                },
                "One_time": {
                    "Training_Cost": 1500,
                    "Premium": 500
                }

            }

        }
    )
    const [pricingCalculationData, setpricingCalculationData] = useState(null);
    const [pricingFeatureData, setPricingFeatureData] = useState(null);
    const [featureConfigData, setFeatureConfigData] = useState(
        {
            "Project_details": {
                "License_mode": "Sale",
                "Project_duration": 14
            },
            "Tier_discount": {
                "0to10": 0,
                "11to50": 0.1,
                "51to100": 0.15,
                "101to150": 0.2,
                "151+": 0.25
            },
            "Duration_discount": {
                "1 Year": 0,
                "2 Year": 0.05,
                "3 Year": 0.1,
                "5 Year": 0.15,
                "Perpetual": 0.2
            },
            "Recovery_details": {
                "Payback": {
                    "Duration_months": 12,
                    "Units_sold/rent": 100
                },
                "margin": 0.7
            },

            "Welding_system": {
                "M-500": {
                    "_comment": "Cost spent on building the licensing platform",
                    "Dev_cost": 500000,
                    "Basic": {
                        "_comment": "Bulding the License platform",
                        "Selected": "Yes",
                        "Dev_weightage": 0.8,
                        "Purchase_probability": 1,
                        "Duration": "Perpetual",
                        "Quantity": 1
                    },
                    "Solid Wire": {
                        "_comment": "Adding the soild wire license to the platform",
                        "Selected": "No",
                        "Dev_weightage": 0.05,
                        "Purchase_probability": 0.5,
                        "Duration": "1 Year",
                        "Quantity": 1
                    },
                    "Horizontal Tracking": {
                        "_comment": "Adding the Horizontal tracking license to the platform",
                        "Selected": "No",
                        "Dev_weightage": 0.05,
                        "Purchase_probability": 0.5,
                        "Duration": "1 Year",
                        "Quantity": 1
                    },
                    "Fronius Power Supply": {
                        "_comment": "Adding the Fronius Power Supply license to the platform",
                        "Selected": "No",
                        "Dev_weightage": 0.05,
                        "Purchase_probability": 0.5,
                        "Duration": "1 Year",
                        "Quantity": 1
                    },
                    "Lincoln Power Supply": {
                        "_comment": "Adding the Lincoln Power Supply license to the platform",
                        "Selected": "No",
                        "Dev_weightage": 0.05,
                        "Purchase_probability": 0.5,
                        "Duration": "1 Year",
                        "Quantity": 1
                    }
                },
                "P-625": {
                    "_comment": "Cost spent on building the licensing platform",
                    "Dev_cost": 500000,
                    "Basic": {
                        "_comment": "Bulding the License platform",
                        "Selected": "Yes",
                        "Dev_weightage": 0.8,
                        "Purchase_probability": 1,
                        "Duration": "Perpetual",
                        "Quantity": 1
                    },
                    "360 degree Welding": {
                        "_comment": "Adding the 360 Degree Welding license to the platform",
                        "Selected": "No",
                        "Dev_weightage": 0.05,
                        "Purchase_probability": 0.5,
                        "Duration": "1 Year",
                        "Quantity": 1
                    },
                    "Zone to Zone Ramping": {
                        "_comment": "Adding the Zone to Zone Ramping license to the platform",
                        "Selected": "No",
                        "Dev_weightage": 0.05,
                        "Purchase_probability": 0.5,
                        "Duration": "1 Year",
                        "Quantity": 1
                    },
                    "Touch ramp": {
                        "_comment": "Adding the Touch Ramp license to the platform",
                        "Selected": "No",
                        "Dev_weightage": 0.05,
                        "Purchase_probability": 0.5,
                        "Duration": "1 Year",
                        "Quantity": 1
                    },
                    "Fronius Power Supply": {
                        "_comment": "Adding the Fronius TPSI Power Supply license to the platform",
                        "Selected": "No",
                        "Dev_weightage": 0.05,
                        "Purchase_probability": 0.5,
                        "Duration": "1 Year",
                        "Quantity": 1
                    }
                }
            }
        }
    )

    useEffect(() => {


        {
            (async () => {


                const config = await getConfogListFromDatabse()
                ///console.log('confog', config)
                if (config && config[0] && config[0].Configuration) {
                    setConfigData(config[0])
                    setFormData(config[0].Configuration)
                }
                if (config && config[1] && config[1].Configuration) {
                   setFeatureConfigData(config[1].Configuration)
                }
                //setFormData(config.Configuration)
            })();
        }


    }, [])
    useEffect(() => {
        authenticateCurrentUser()
            .then(async (data) => {
                if (data.signInUserSession.accessToken.payload["cognito:groups"]) {

                    let response = data.signInUserSession.accessToken.payload["cognito:groups"] //await getA(data.username)
                    //const userAccess = response.map(item => item?.GroupName)
                    //console.log(response)
                    const userEmail = JSON.parse(localStorage.getItem('user')).email
                    setUserName(userEmail);
                    setUserGroup(response);
                }
            })
            .catch((error) => {
                console.log('error', error);
            });
    }, [history]);
    const handleTabChange = (key) => {

        setActiveKeyLine(key);
        setSelectedTap(tapsList[Number(key) - 1])

    };

    // const handleInputChange = (name, value) => {

    //     setFormData((prevData) => ({ ...prevData, [name]: value }));

    // };

    const onGeneratePricing = async () => {
        setGenerateLoading(true)
        //console.log('Data', formData)
        const res = await generateData360Pricing(formData)
        //console.log('Res', res)
        if (res)
            setpricingCalculationData(res)

        setShowPricingTable(true)
        setGenerateLoading(false)
    }


    const handleInputChange = (category, type, value) => {
        //setIsInputfeildChanged(true)
        //const category = 'Power_Supplies'
        setShowPricingTable(false)
        setIsInputfeildChanged(true)
        setFormData((prevOptions) => {
            const updatedCategory = { ...prevOptions[category] };
            updatedCategory[type] = value;


            return {
                ...prevOptions,
                [category]: updatedCategory,
            };
        });
    }


    const getCategoryValue1 = (category, type) => {
        if (formData.hasOwnProperty(category)) { // Check if the category exists in selectedOptions
            return formData[category][type]; // Return the value for the category
        }
    };

    const handleInputChange1 = (category, type, value) => {
        const maincategory = 'Others'
        setFormData((prevOptions) => {
            // Spread the previous state to avoid mutations
            return {
                ...prevOptions,  // Spread the outermost object
                [maincategory]: {   // Spread the maincategory
                    ...prevOptions[maincategory],  // Keep other categories intact
                    [category]: {  // Spread the specific category to update only the nested type
                        ...prevOptions[maincategory][category],
                        [type]: value,  // Update the specific type with the new value
                    },
                },
            };
        });
    };


    const getCategoryValue2 = (category, type) => {
        const maincategory = 'Others'
        if (formData.hasOwnProperty(maincategory) && formData[maincategory].hasOwnProperty(category)) {
            return formData[maincategory][category][type]; // Return the value for the category and type
        }
        return ''; // Return an empty string or fallback value if not found
    };
    const OnSave = async () => {
        setSaveLoading(true);

        const data = {
            ID: ConfigData.ID,
            Configuration: formData
        }
        //  console.log(data)
        await AddOrUpdateConfigData(data)
        setIsInputfeildChanged(false)
        setSaveLoading(false);

    }

    const onValuesChange = (changedValues, allValues) => {

        setIsInputfeildChanged(true)
    };

    const getPricingTabpanes = () => {
        return (
            <div className="custom-tab h-100 pricing-guidance-page" style={{ paddingTop: '0px' }}>
                <Tabs defaultActiveKey='1' activeKey={activeKeyLine} onChange={handleTabChange}  >
                    {
                        <TabPane tab='DATA360' key='1'>

                            {activeKeyLine == '1' && <div className="flex-auto pricing-guidance-page__panel">


                                {!showConfiguration && <div>

                                    <div className="d-flex mb-2 align-items-center tab-content-title">
                                        <div className="new-calibration">
                                            {userGroup && userGroup.includes('pricing-gudiance-admin') &&

                                                <Button shape="round" key="apply" type="primary" style={{ marginTop: '0px' }}
                                                    onClick={() => setShowConfiguration(true)} >
                                                    Configuration
                                                </Button>

                                            }
                                        </div>
                                    </div>
                                    <Form
                                        layout="vertical"
                                        autoComplete="off"
                                        getcontainer={false}
                                        className="pricing-guidance-form"
                                        onValuesChange={onValuesChange}
                                    >
                                        {/* Project Inputs Section */}
                                        <div className="pricing-guidance-form__fields">
                                            <Row gutter={24}>
                                                <Col span={6}>
                                                    <Form.Item label="No. of Welding Systems" name="No_of_units" required>
                                                            <Input onChange={(e) => handleInputChange('Project_details', 'No_of_units', Number(e.target.value))}
                                                                value={getCategoryValue1('Project_details', 'No_of_units')}
                                                                min={0} size="large" type='number' style={{ textAlign: 'center', }} />
                                                    </Form.Item>
                                                </Col>


                                                <Col span={6}>
                                                    <Form.Item name="License_mode" label="License mode" className='report-radio' required>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                                                            <Radio.Group
                                                                value={Contractor}
                                                                onChange={async (e) => {
                                                                    handleInputChange('Project_details', 'License_mode', e.target.value);
                                                                    setContractor(e.target.value);
                                                                }}
                                                            >
                                                                <Radio value={"Rent"} style={{ marginTop: '5px' }}>Rent</Radio>
                                                                <Radio value={"Sale"} style={{ marginTop: '5px' }}>Sale</Radio>
                                                            </Radio.Group>
                                                        </div>
                                                    </Form.Item>
                                                </Col>
                                                {Contractor == 'Rent' &&
                                                    <Col span={6}>
                                                        <Form.Item label="Project Duration (months)" name="Project_duration" required>
                                                                <Input onChange={(e) => handleInputChange('Project_details', 'Project_duration', Number(e.target.value))}
                                                                    value={getCategoryValue1('Project_details', 'Project_duration')}
                                                                    min={0} size="large" type='number' style={{ textAlign: 'center' }} />
                                                        </Form.Item>
                                                    </Col>
                                                }

                                                {Contractor == 'Sale' &&
                                                    <Col span={6}>
                                                        <Form.Item label="License Duration" name="License_Duration" required className='report-radio'>
                                                                <Select placeholder="Select License Duration" className='maintenance-select'
                                                                    size="large" onChange={(value) => handleInputChange('Project_details', 'License_duration', value)}
                                                                    value={getCategoryValue1('Project_details', 'License_duration')}
                                                                >
                                                                    <Option value="1 Year">1 Year</Option>
                                                                    <Option value="2 Year">2 Year</Option>
                                                                    <Option value="3 Year">3 Year</Option>
                                                                    <Option value="5 Year">5 Year</Option>
                                                                    <Option value="Perpetual">Perpetual</Option>
                                                                </Select>
                                                        </Form.Item>
                                                    </Col>
                                                }

                                                <Col span={6}>
                                                    <Form.Item label="License Tier" name="License_Tier" className='report-radio' required>
                                                            <Select placeholder="Select License Tier" className='maintenance-select1' size="large"
                                                                onChange={(value) => handleInputChange('Project_details', 'Tier', value)}
                                                                value={getCategoryValue1('Project_details', 'Tier')}
                                                            >
                                                                <Option value="Basic">Basic</Option>
                                                                <Option value="Standard">Standard</Option>
                                                                <Option value="Premium">Premium</Option>
                                                            </Select>
                                                    </Form.Item>
                                                </Col>



                                            </Row>
                                        </div>
                                    </Form>
                                </div>
                                }





                                {!showConfiguration &&

                                    <div className="pricing-guidance-actions">

                                        <Button shape="round" key="apply" type="primary" style={{ marginTop: '00px' }}
                                            onClick={() => onGeneratePricing()} loading={GenerateLoading}
                                        >
                                            Generate Pricing
                                        </Button>
                                        {pricingCalculationData && showPricingTable &&
                                            <div className="pricing-guidance-results">
                                                <div className="pricing-guidance-message">
                                                    {pricingCalculationData.message ?? ''}
                                                </div>

                                                <PricingTable
                                                    currentDetailCalculation={pricingCalculationData}
                                                    formData={formData}

                                                ></PricingTable>
                                            </div>
                                        }

                                    </div>
                                }
                            </div>
                            }
                        </TabPane>


                    }
                    {
                        <TabPane tab='Feature License' key='2'>




                            <FeatureLicensePage
                                setFeatureConfigData={setFeatureConfigData}
                                featureConfigData={featureConfigData}
                                showConfiguration={showFeatureConfiguration}
                                setShowConfiguration={setShowFeatureConConfiguration}
                            >

                            </FeatureLicensePage>




                        </TabPane>
                    }

                </Tabs>



            </div>
        );
    }



    return (

        <div className="d-flex flex-column h-100">
        
                <div>
                    <div className="flex-auto">
                        <div className="d-flex mb-3 align-items-center tab-content-title">


                            <div className='back_equip' >
                                <Tooltip title={'Back'} >
                                    <ArrowLeftOutlined onClick={(e) => {
                                        if (showConfiguration)
                                            setShowConfiguration(false)
                                        if (showFeatureConfiguration)
                                            setShowFeatureConConfiguration(false)
                                        history.push(showConfiguration || showFeatureConfiguration ? '/Data360Pricing' : '/SmartLync-HomePage');
                                    }} />
                                </Tooltip>
                            </div>

                            <Title className="mb-0 add-new-calibration" level={3} style={{ paddingLeft: '30px' }}>
                                {showConfiguration || showFeatureConfiguration ? 'Configuration' : 'Pricing Guidance'}
                            </Title>

                            {/* <div className="new-calibration">
                                {userGroup && userGroup.includes('pricing-gudiance-admin') &&

                                    <Button shape="round" key="apply" type="primary" style={{ marginTop: '00px' }}
                                        onClick={() => setShowConfiguration(true)} >
                                        Configuration
                                    </Button>

                                }
                            </div> */}
                        </div>
                    </div>
                    {showConfiguration &&


                        <Data360Config
                            setConfigData={setConfigData}
                            ConfigData={ConfigData}
                            setFormData={setFormData}
                            formData={formData}
                            showConfiguration={showConfiguration}
                            Contractor={Contractor}
                            setShowConfiguration={setShowConfiguration}
                        >

                        </Data360Config>

                    }

                    {showFeatureConfiguration &&


                        <FeatureLicenseConfig
                            setConfigData={setConfigData}
                            ConfigData={ConfigData}
                            setFormData={setFeatureConfigData}
                            formData={featureConfigData}
                            showConfiguration={showConfiguration}
                            //  Contractor={Contractor}
                            setShowConfiguration={setShowConfiguration}
                        >

                        </FeatureLicenseConfig> 
                    }
                    { !showConfiguration && !showFeatureConfiguration && getPricingTabpanes()

                    }

                </div>

            
        </div>
    );
};
const mapStateToProps = ({ }) => {
    // const projectList = get(PricingListReducer, 'PricingList', []);

    // const isLoading = get(PricingListReducer, 'isFetchLoading', false);
    // const listCount = get(PricingListReducer, 'PricingListCount', null);
    // const listTotalCount = get(PricingListReducer, 'PricingListTotalCount', null);

    return {
        // projectList,
        // isLoading,
        // listCount,
        // listTotalCount
    }
}

const mapDispatchToProps = {

    // onPricingList: fetchPricingdList,
}


export default connect(mapStateToProps, mapDispatchToProps)(Data360Page);

